import React, { FC, useMemo } from "react";
import Head from "next/head";
import ResetCss from "components/front/layout/ResetCss";

const AnimeFurusatoLpHead: FC = () => {
  const robotsValue = useMemo(() => {
    return process.env.APP_ENV === "production" ? "all" : "noindex";
  }, []);
  return (
    <>
      <Head>
        <title>【公式】アニメふるさと納税とは？｜アニメファンド</title>
        <meta
          name="description"
          content="アニメふるさと納税とは、税金の一部を自治体に寄附することで税金の還付や控除がされ、特別なアニメ返礼品などを受け取れる仕組みです。"
        />
        <meta
          name="keywords"
          content="アニメ ふるさと納税,アニメ,アニメーター,製作委員会,制作会社,ふるさと納税,ふるさと納税 特産品,寄附 税金控除,ふるさと納税 控除,ふるさと納税 特典,ふるさと納税 計算,ふるさと応援,ふるさと納税 おすすめ"
        />
        <link rel="canonical" href={`${process.env.API_CF_BASE_URL}/lp/animefurusato`} />
        <meta property="og:title" content="アニメふるさと納税とは？｜ふるさと納税サイト [アニメファンド]" />
        <meta
          property="og:description"
          content="税金の一部を自治体に寄附することで税金の還付や控除がされ、特別なアニメ返礼品などを受け取れる仕組みです。"
        />
        <meta property="og:image" content={`${process.env.API_CF_BASE_URL}/project-preview/furusato/hero.png`} />
        <meta property="og:url" content={`${process.env.API_CF_BASE_URL}/lp/animefurusato`} />
        <meta property="og:site_name" content="アニメファンド" />
        <meta property="og:locale" content="ja_JP" />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@animefund" />
        <meta property="fb:app_id" content="2809748165906745" />
        <meta name="robots" content={robotsValue} />
      </Head>
      <ResetCss />
    </>
  );
};
export default AnimeFurusatoLpHead;
